export default "__VITE_ASSET__DOCkC$95__"